import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "computerWithChecklistBehind",
    iconColor: "white",
    text: "Continuous audits and risk \nassessments to safeguard against \npitfalls",
    listItemCustomStyle: { width: "400px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "eyeFocus",
    iconColor: "white",
    text: "Continuous market scans to\nidentify shifts in the tech,\nlegal, and security landscape",
    listItemCustomStyle: { width: "368px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "phoneWithBoxesConnected",
    iconColor: "white",
    text: "Telemetry to check AI\ncompliance footprint",
    listItemCustomStyle: { width: "316px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

const DATA_BENEFITS = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: "Infosys ai3s - scan",
  titleNumber: "1.",
  text: "Scan suite of offerings helps enterprises identify the overall risk posture, \nlegal obligations, vulnerabilities, and threats arising due to AI adoption \nusing a set of offerings named 'Scan' that collate information from \nmultiple external and internal sources and create a single source of truth \nfor tracking the risk and compliance status of all AI projects.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "NEXT",
    onClick: () => setCurrentPage(303),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(301),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "RESPONSIBLE_AI/AI3S_d1_02.png",
};

export default DATA_BENEFITS;
